import { render, staticRenderFns } from "./Foreign.vue?vue&type=template&id=4b54c2d0&"
import script from "./Foreign.vue?vue&type=script&lang=js&"
export * from "./Foreign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports